import {
  ApplicationConfig,
  inject,
  PLATFORM_ID,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
  provideZonelessChangeDetection,
  REQUEST_CONTEXT
} from '@angular/core';
import {provideRouter, withComponentInputBinding} from '@angular/router';

import {routes} from './app.routes';
import {provideClientHydration, withIncrementalHydration} from '@angular/platform-browser';
import {initializeApp, initializeServerApp, provideFirebaseApp} from "@angular/fire/app";
import {environment} from "../environments/environment";
import {BrowserHomepageNoticeFetchService, HomepageNoticeFetchService} from "./home-page/homepage-notice-fetch-service";
import {BrowserSchedulingService, SchedulingService} from "./scheduling.service";
import {SeoService} from "./seo/seo.service";
import {BrowserSeoService} from "./seo/browser-seo.service";
import {isPlatformBrowser} from "@angular/common";
import {BrowserTrackingService, TrackingService} from "./tracking/tracking.service";

export const appConfig: ApplicationConfig = {
  providers: [
    provideZonelessChangeDetection(),
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes, withComponentInputBinding()),
    provideClientHydration(withIncrementalHydration()),
    {provide: HomepageNoticeFetchService, useClass: BrowserHomepageNoticeFetchService},
    {provide: SchedulingService, useClass: BrowserSchedulingService},
    {provide: SeoService, useClass: BrowserSeoService},
    {provide: TrackingService, useClass: BrowserTrackingService},
    provideFirebaseApp(() => {
      if (isPlatformBrowser(inject(PLATFORM_ID))) {
        return initializeApp(environment.firebaseConfig);
      }
      const requestContext = inject(REQUEST_CONTEXT, {optional: true}) as
        | { authIdToken?: string }
        | null;
      if (!requestContext?.authIdToken) {
        return initializeApp(environment.firebaseConfig);
      }
      return initializeServerApp(environment.firebaseConfig, {
        authIdToken: requestContext.authIdToken,
        releaseOnDeref: requestContext,
      });
    }),
    provideAppInitializer(() => {
      inject(TrackingService);
    })
  ]
};
